/* Wishlist page — shows the wishlisted products (port of original `BK`). */
(function () {
  if (customElements.get('wishlist-page')) return;

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.loading = this.querySelector('[data-wishlist-loading]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.fetched = {};

      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-remove]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var h = btn.getAttribute('data-wishlist-remove');
        if (window.BrogiWishlist) BrogiWishlist.remove(h);
        if (window.BrogiToast) BrogiToast.show(self.dataset.removed || 'Removed from wishlist');
      });
      this._onChange = function () { self.render(); };
      document.addEventListener('brogi:wishlist-change', this._onChange);
      window.addEventListener('storage', this._onChange);

      this.whenReady(function () { self.render(); });
    }

    disconnectedCallback() {
      document.removeEventListener('brogi:wishlist-change', this._onChange);
      window.removeEventListener('storage', this._onChange);
    }

    whenReady(cb) {
      if (window.BrogiWishlist) return cb();
      document.addEventListener('brogi:ready', cb, { once: true });
      window.addEventListener('load', function () { cb(); }, { once: true });
    }

    items() {
      try { return (window.BrogiWishlist && BrogiWishlist.items()) || []; } catch (e) { return []; }
    }

    render() {
      var self = this;
      var items = this.items();
      var known = {};
      var shown = 0;
      this.grid.querySelectorAll('[data-wishlist-item]').forEach(function (el) {
        var h = el.getAttribute('data-wishlist-item');
        known[h] = true;
        var show = items.indexOf(h) > -1;
        if (show && el.hidden) {
          el.style.animationDelay = (shown * 0.08) + 's';
          el.classList.add('is-entering');
        }
        el.hidden = !show;
        if (show) shown++;
      });

      // Wishlisted products that are not part of the source collection → theme product card.
      var missing = items.filter(function (h) { return !known[h] && !self.fetched[h]; });
      if (missing.length && window.Brogi && Brogi.fetchProductCards) {
        missing.forEach(function (h) { self.fetched[h] = true; });
        Brogi.fetchProductCards(missing).then(function (htmls) {
          htmls.forEach(function (html, i) {
            if (!html) return;
            var wrap = document.createElement('div');
            wrap.className = 'wishlist-item';
            wrap.setAttribute('data-wishlist-item', missing[i]);
            wrap.setAttribute('data-wishlist-extra', '');
            wrap.hidden = true;
            wrap.innerHTML = html;
            self.grid.appendChild(wrap);
            if (Brogi.init) Brogi.init(wrap);
          });
          self.render();
        });
        if (!shown) return; // keep skeleton until the extra cards arrive
      }

      this.loading.hidden = true;
      this.grid.hidden = shown === 0;
      this.empty.hidden = shown > 0;
    }
  }
  customElements.define('wishlist-page', WishlistPage);
})();
